import React, { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone'
import Cookies from 'universal-cookie';
const NominationUpload = ({
  award_category,
  nomination
}) => {
  const [ pdfAttachmentUrl, setPdfAttachmentUrl ] = useState(nomination.pdf_attachment_url)
  const [ uploadId, setUploadId ] = useState(nomination.upload_id)
  const [ loading, setLoading ] = useState(false)
  const renderHiddenFields = () => {
    return (
      <div>
        <input type="hidden" name="nomination[pdf_attachment_url]" value={pdfAttachmentUrl} />
        <input type="hidden" name="nomination[upload_id]" value={uploadId} />
      </div>
    )
  }

  const onDrop = (files) => {
    setLoading(true)
    const formData = new FormData();
    formData.append('file', files[0]);
    
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");

    fetch(`/uploads`, {
      method: 'POST',
      body: formData,
      headers : {
        "X-CSRF-Token": token,
      }
    }).then((response) => {
      if (response.ok) {
        response.json().then((data) => {
          setUploadId(data.upload.id)
          setPdfAttachmentUrl(data.url)
          setLoading(false)
        })
      }
    })
  }

  const renderDropzone = () => {
    return (
      <>
      <label class="text required" for="nomination_award_criteria_responses_2">
        <abbr title="required">*</abbr>
        Please upload at least one supporting document for your submission (i.e. sample creative, reports, feedback, video, or campaign overview).
      </label>
      <Dropzone  onDrop={onDrop}>
        
        {({getRootProps, getInputProps}) => (
          <>
          {pdfAttachmentUrl ? <a href={pdfAttachmentUrl} target="__blank">Download Uploaded PDF</a> : null}
          <div className="upload-container">
          
          <section id="drop-area">
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <div class="upload-text">
              <div class="upload-logo">
                <i class={loading ? "fa fa-spinner fa-pulse" :"fa fa-arrow-down"}></i>
                </div>
                <div class="upload-details"></div>
                <div class="btn secondary">{pdfAttachmentUrl ? 'Replace file' : 'Select file to upload'}</div>
              </div>
            </div>
          </section>
          </div>
          </>
        )}
      </Dropzone>
      </>
    )
  }
  return (
    <div>
      {renderHiddenFields()} 
      {renderDropzone()}
    </div>
  )
  
}

export default NominationUpload